import { render, staticRenderFns } from "./EditorLinha.vue?vue&type=template&id=a76f0fae"
import script from "./EditorLinha.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorLinha.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports